<template>
  <div class="alls">
  <div class="alls_list">
    <div class="boxs_photo">
      <div class="imfsewz"></div>
      <div class="boxs">
        <img src="../assets/logo6.png" alt="">
        <el-form ref="form" :model="form"  label-position="left" size="middlo">
            <div class="itemlist">
            <i class="el-icon-aligeren"></i>
            <input class="inputdys" type="text" v-model="form.username" placeholder="请输入账号">
          </div>
            <div class="itemlist">
              <i class="el-icon-alimima"></i>
              <input class="inputdys" :type="inputType" v-model="form.pwd"  placeholder="请输入密码">
              <span class="input-group-addon" @click="toggleVisibility">
                <i style="color: #2c2c2c;" :class="iconClass"></i>
              </span>
              <!-- <el-image :src="src" @click="getCap()"></el-image> -->
            </div>
            <div class="itemlist">
              <i class="el-icon-aliyanzhengma"></i>
              <input class="inputdys" type="text" v-model="form.imgCode"  placeholder="请输入验证码">
              <el-image :src="src" @click="getCap()"></el-image>
          </div>
        </el-form>
        <p class="p3" @click="loginin()">登录</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
let base64 = require('js-base64').Base64;
import { decryptSignKey, storeSignKey } from '../utils/sign'
export default {
  data(){
    return{
      form:{
          username:'',
          pwd:'',
          imgCode:"",
          verifyUuid:""
      },
      inputType: 'password',
      iconClass: 'el-icon-aliyanjing-guan',
      src:'',
    }
  },
  created(){
    this.getCap()
  },
  mounted(){
    
      // 确保组件已经被挂载
    this.$nextTick(() => {
    if (this.$refs.form) {
      // 添加事件监听器
      this.$refs.form.$el.addEventListener('keydown', this.handleSubmit);
    }
    });
  },
  methods:{
    toggleVisibility() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
      this.iconClass = this.iconClass === 'el-icon-aliyanjing-guan' ? 'el-icon-aliyanjing' : 'el-icon-aliyanjing-guan';
    },
      getCap(){
        var dt = new Date().getTime(); // 当前时间
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c === 'x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.form.verifyUuid = uuid
          this.$api.Caps({
            verifyUuid:uuid
          }).then((res)=>{
              this.src = res.data.data.imageBase64
          })
      },
      loginin(){
          // this.$router.push('/Home');
          this.$api.Login({
              username:this.form.username,
              pwd:this.form.pwd,
              verifyUuid:this.form.verifyUuid,
              imgCode:this.form.imgCode 
          }).then((res) => {
              if(res.data.code ==200){
                let data = res.data.data
                  sessionStorage.setItem('saTokenInfo', JSON.stringify(data.saTokenInfo))
                  localStorage.setItem('token',data.saTokenInfo.tokenValue)
                  sessionStorage.setItem('username',data.userName)
                  // 解密后端返回的 signKey 并存储，用于后续请求签名
                  const rawSignKey = decryptSignKey(data.signKey)
                  storeSignKey(rawSignKey)
                  this.$router.push('/navigation');
              }else{
                  this.$message.error(res.data.message);
                  this.getCap()
              }
          })
      },
      handleSubmit(event){
        if (event.key === 'Enter') {
          this.loginin()
        }
      }
  },
  beforeDestroy(){
    this.$refs.form.$el.removeEventListener('keydown', this.handleSubmit);
  }
}
</script>

<style scoped>
.alls{
  width: 100%;
  height: 100%;
  background-size: cover;
  background-attachment: fixed ;
  background-position: center center;
  /* background-color: #124B6B; */
  background-image: url(../assets/bj.png);
  background-repeat: no-repeat;
}
.alls_list{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.boxs{
  padding: 60px 30px 60px 30px;
  background-color: rgba(255, 255, 255);
  box-sizing: border-box;
  text-align: center;
  border-radius: 30px;
}
.boxs_photo{
  width: 100%;
  display: flex;
  justify-content: center;
}
.boxs_photo .imfsewz{
  width: 40%;
  height: 40%;
}
.boxs .p3{
  width: 75%;
  text-align: center;
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 11px 16px;
  background-color: #017EFF;
  color: #fff;
  font-weight: bold;
  font-size: 17px;
  letter-spacing: 3px;
  margin-top: 80px;
  border-radius: 8px;
  cursor: pointer;
}
.labs{
  color: #409EFF;
  font-size: 16px;
  font-weight: bold;
}
.yanzheng{
  position: relative;
}
.yzimg{
  position: absolute;
  right: 10px;
  top: 75%;
  transform: translateY(-50%);
  height: 36px;
  width: auto;

}
.boxs h2{
  color: #007AFF;
  text-align: center;
  line-height: 2;
  font-size: 30px;
  margin-bottom: 30px;
}
.itemlist{
  width: 447px;
  height: 68px;
  display: flex;
  align-items: center; /* 这个属性负责垂直居中 */
  justify-content: center;
  background: #F5F5F5;
  border-radius: 60px;
  margin: 30px auto;
  position: relative;
  
}
.inputdys{
  width: 352px;
  height: 45px;
  border: 0px;
  background: #F5F5F5;
  font-size: 20px;
  margin-left: 10px;
}
.inputdys:focus {
  outline: none;
}
.itemlist /deep/ .el-image{
  position: absolute;
  right: 20px;
}
.input-group-addon {
  position: absolute;
  right: 20px;
  top: 15px;
  bottom: 0;
  height: auto;
  cursor: pointer;
  color: #3398DB;
}
</style>


// WEBPACK FOOTER //
// src/login/Login.vue